module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-box"
  }, [_c('div', {
    staticClass: "banner"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("产品优势")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("8大行业解决方案")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("添加客服微信了解更多")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "signnow",
    on: {
      "click": function($event) {
        _vm.signup()
      }
    }
  }, [_vm._v("立即注册")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-1"
  }, [_c('span', {
    staticClass: "content-1-box content-1-box1"
  }, [_c('span', {
    staticClass: "base-span"
  }, [_vm._v("基础功能\n              限时免费")]), _vm._v(" "), _c('span', {
    staticClass: "dec-span"
  }, [_vm._v("\n          支持实体店各类日常管理\n          不花钱也能用上好软件\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "content-1-box content-1-box2"
  }, [_c('span', {
    staticClass: "base-span"
  }, [_vm._v("门店网店\n全打通")]), _vm._v(" "), _c('span', {
    staticClass: "dec-span"
  }, [_vm._v("\n          线上线下同步互通\n无需分开搭理 轻松运营\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "content-1-box content-1-box3"
  }, [_c('span', {
    staticClass: "base-span base-span1"
  }, [_vm._v("一个软件解决所有\n开店问题")]), _vm._v(" "), _c('span', {
    staticClass: "dec-span"
  }, [_vm._v("\n          会员 收银 商品\n一个软件轻松管理\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "content-1-box content-1-box4"
  }, [_c('span', {
    staticClass: "base-span base-span2"
  }, [_vm._v("支持多端登录 无需更换硬件")]), _vm._v(" "), _c('span', {
    staticClass: "dec-span"
  }, [_vm._v("\n          手机 电脑 收银一体机\n手持pos机 iPad\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-2"
  }, [_c('span', {
    staticClass: "left-box"
  }, [_c('span', [_c('span', {
    staticClass: "span-1"
  }, [_vm._v("小程序解决方案")])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "span-2"
  }, [_vm._v("服务行业解决方案")])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "span-3"
  }, [_vm._v("连锁店解决方案")])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "span-4"
  }, [_vm._v("餐饮解决方案")])])]), _vm._v(" "), _c('span', {
    staticClass: "right-box"
  }, [_c('span', [_c('span', {
    staticClass: "span-5"
  }, [_vm._v("新零售解决方案")])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "span-6"
  }, [_vm._v("母婴解决方案")])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "span-7"
  }, [_vm._v("扫码收款解决方案")])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "span-8"
  }, [_vm._v("批发行业解决方案")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-3"
  }, [_c('span', {
    staticClass: "content-title"
  }, [_vm._v("门店管理")]), _vm._v(" "), _c('img', {
    staticClass: "content-img",
    attrs: {
      "src": require("../../assets/images/new-activity/mendianguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content-wordbox"
  }, [_c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/shouying.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("收银管理：")]), _vm._v(" "), _c('span', [_vm._v("清楚每一笔销售，管好每一笔钱")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/stock.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("商品库存管理：")]), _vm._v(" "), _c('span', [_vm._v("货品成千上万，轻松管理，门店网店全统一")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/dianyuanguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("店员管理：")]), _vm._v(" "), _c('span', [_vm._v("清楚每一笔销售，管好每一笔钱")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/liansuo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("连锁店管理：")]), _vm._v(" "), _c('span', [_vm._v("店铺间会员、优惠券等互通，管理一步到位")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-3"
  }, [_c('span', {
    staticClass: "content-title"
  }, [_vm._v("会员营销")]), _vm._v(" "), _c('img', {
    staticClass: "content-img2",
    attrs: {
      "src": require("../../assets/images/new-activity/yingxiao.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content-wordbox"
  }, [_c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/duanxin.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("短信营销：")]), _vm._v(" "), _c('span', [_vm._v("低成本高质量触达顾客，数百种短信模板")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/wechatcard.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("微信会员卡：")]), _vm._v(" "), _c('span', [_vm._v("直连微信卡券，高端大气，营销通知免费发")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/wxstore.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("小程序微信商城：")]), _vm._v(" "), _c('span', [_vm._v("清楚每一笔销售，管好每一笔钱")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/huodong.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("营销活动中心：")]), _vm._v(" "), _c('span', [_vm._v("提供多达40种营销活动组合，吸引新顾客，回顾老顾客，让生意来的更快、更省心")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-3"
  }, [_c('span', {
    staticClass: "content-title"
  }, [_vm._v("商品管理")]), _vm._v(" "), _c('img', {
    staticClass: "content-img3",
    attrs: {
      "src": require("../../assets/images/new-activity/guanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content-wordbox"
  }, [_c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/zhineng.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("智能盘点：")]), _vm._v(" "), _c('span', [_vm._v("告别复杂的商品盘点流程,帮您快速盘点")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/storeguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("商品库存管理：")]), _vm._v(" "), _c('span', [_vm._v("可将客人购买过的商品寄存系统内,提升到店率")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/duoguige.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("多规格/串码管理：")]), _vm._v(" "), _c('span', [_vm._v("支持商品多规格/多串码录入,管理商品多样性")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/kunbang.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("商品捆绑销售：")]), _vm._v(" "), _c('span', [_vm._v("可将多款商品捆绑组合销售,优惠促销更方便")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-3"
  }, [_c('span', {
    staticClass: "content-title"
  }, [_vm._v("低费率聚合收款，快又省！")]), _vm._v(" "), _c('img', {
    staticClass: "content-img4",
    attrs: {
      "src": require("../../assets/images/new-activity/difei.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content-wordbox"
  }, [_c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/wx.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("微信、支付宝收款，0.35超低费率：")]), _vm._v(" "), _c('span', [_vm._v("一年净省500元，支持自定义美团、饿了么等支付方式")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/zhifu.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("支付即为会员，留住每一位付款用户：")]), _vm._v(" "), _c('span', [_vm._v("顾客付款后即可添加或领卡成为会员")])])]), _vm._v(" "), _c('span', {
    staticClass: "content-wordspan"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/saoma.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('span', [_vm._v("每一款都含扫码硬件：")]), _vm._v(" "), _c('span', [_vm._v("套餐搭配新潮流硬件，至少再省200元")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "service-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/qrcode.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("全国客服电话")]), _vm._v(" "), _c('span', {
    staticClass: "phone"
  }, [_vm._v("400-168-3399")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tel"
  }, [_c('a', {
    attrs: {
      "href": "tel:400-168-3399"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-activity/tel.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6668e5e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-activity/index.vue
// module id = 392
// module chunks = 0